const servers = {
    //PRO
    "empleabilidad.educaedtech.com": "https://gestion.educaedtech.com",
    //PRE
    "portal-educaedtech.dev.doubledot.es": "https://sandbox-educaedtech.dotia.es",
    //LOCAL
    "localhost:8080": "https://localhost:44379",
}

export default servers;


// WEBPACK FOOTER //
// ./src/servers/index.js